<template>
  <p :class="textClasses">
    <slot />
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  variant?: 'primary' | 'secondary'
  size?: 'small' | 'medium' | 'large' | 'xsmall'
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'medium'
})

// Map variant to classes
const textClasses = computed(() => {
  const sizeClasses = {
    small: 'text-xs',
    medium: 'text-sm',
    large: 'text-base'
  }
  
  const variantClasses = {
    primary: 'text-typography-primary',
    secondary: 'text-typography-secondary font-medium'
  }
  
  return [
    sizeClasses[props.size as keyof typeof sizeClasses],
    variantClasses[props.variant]
  ].join(' ')
})
</script>
